import { render, staticRenderFns } from "./AddOrderPalletsModal.vue?vue&type=template&id=6d53f1be"
import script from "./AddOrderPalletsModal.vue?vue&type=script&lang=ts"
export * from "./AddOrderPalletsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports